import * as React from "react";
import classNames from "classnames";
import Title from "~/components/title/title";
import { useAccordion } from "../accordion/useAccordion";
import AccordionItem from "../accordion/accordion-item/accordion-item";
import AccordionHeader from "../accordion/accordion-header/accordion-header";
import AccordionContent from "../accordion/accordion-content/accordion-content";
import Accordion from "../accordion/accordion";
import ContentSection from "../content-section/content-section";

interface accordionItem {
    title?: string;
    richText?: string;
}

export interface FAQAccordionProps {
    title?: string;
    isTitleH1?: boolean;
    richText?: string;
    accordionItems?: accordionItem[];
    hasColumns?: boolean;
    disableBackgroundColor?: boolean;
    anchorId?: string;
    hasNoMarginTop?: boolean;
    hasNoMarginBottom?: boolean;
}

const FAQAccordion: React.FC<FAQAccordionProps> = ({
    title,
    isTitleH1,
    richText,
    accordionItems,
    hasColumns,
    disableBackgroundColor,
    ...props
}) => {
    const [activeIndex, setActiveIndex] = useAccordion();
    const baseClass = "faq-accordion";
    const componentClasses = classNames(baseClass, {
        [`content-section-full--no-background`]: disableBackgroundColor,
        [`${baseClass}--theme-background`]: !disableBackgroundColor,
        [`${baseClass}--has-columms`]: hasColumns
    });

    return (
        <ContentSection
            className={componentClasses}
            type={disableBackgroundColor ? "default" : "full"}
            {...props}
        >
            <div className={`${baseClass}__inner`}>
                <div className={`${baseClass}__text-wrapper`}>
                    {title && <Title title={title} isTitleH1={isTitleH1} />}
                    {richText && (
                        <div className="content-rich-text" dangerouslySetInnerHTML={{ __html: richText }} />
                    )}
                </div>
                {accordionItems && (
                    <div className={`${baseClass}__accordion-wrapper`}>
                        <Accordion>
                            {accordionItems.map((item, index) => {
                                const isActive = activeIndex === index;
                                return (
                                    <AccordionItem
                                        key={index}
                                        isActive={isActive}
                                        duration={500}
                                        renderHeader={
                                            <AccordionHeader
                                                isActive={isActive}
                                                onClick={() => setActiveIndex(index)}
                                            >
                                                {item.title}
                                            </AccordionHeader>
                                        }
                                        renderContent={
                                            <AccordionContent>
                                                {item.richText && (
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: item.richText
                                                        }}
                                                    />
                                                )}
                                            </AccordionContent>
                                        }
                                    />
                                );
                            })}
                        </Accordion>
                    </div>
                )}
            </div>
        </ContentSection>
    );
};

export default FAQAccordion;
